import angular from 'angular'
import template from '../components/template.html'

angular.module('nominas.carganominaasalariados')
  .config(Config);

function Config($stateProvider) {
  $stateProvider.state('nominas.cargaNominaAsalariados', {
    url: '/cargaNominaAsimilados?{idEmpresa}&{idNomina}',
    data: {
      title: 'Carga de Nómina Asimilados',
    },
    resolve: {
      Auth: ['Permisos', function (Permisos) {
        return Permisos.validar(function () {
          return Permisos.modulos({
            cargaNominaAsimilados: 'payrolls.vaciadoNomina',
          }).then(function (modulos) {
            return modulos.cargaNominaAsimilados;
          });
        });
      }],
      permisos: ['Permisos', function (Permisos) {
        return Permisos.modulos({
          detalladoNomina: 'Payrolls.summary',
        });
      }],
      nominas: ['$stateParams', 'NominasCargaNominaAsalariados', function ($stateParams, NominasCargaNominaAsalariados) {
        return $stateParams.idEmpresa
          ? NominasCargaNominaAsalariados.catalogo($stateParams.idEmpresa)
          : undefined;
      }],
      empresas: ['$catalogos', function ($catalogos) {
        return $catalogos.get('empresas');
      }],
      Catalogos: ['$catalogos', '$session', 'nominas', 'empresas', 'Auth', function ($catalogos, $session, nominas, empresas) {
        return $catalogos.$fetch()
          .then(function (Catalogos) {
            return {
              Nominas: nominas,
              Monedas: Catalogos.Monedas,
              Empresas: empresas,
            };
          });
      }],
    },
    controllerAs: '$ctrl',
    controller: Component,
    template: template,
  });
}

function Component(NominasCargaNominaAsalariados, permisos, Catalogos, $dialog, $stateParams, $location, $q) {
  let $ctrl = this,
    index = {};

  $ctrl.catalogos = Catalogos;
  $ctrl.auth = permisos;
  $ctrl.data = [];
  $ctrl.saved = false;
  $ctrl.addMultiple = agregarMultiple;
  $ctrl.editar = editar;
  $ctrl.clear = borrar;
  $ctrl.save = guardar;
  $ctrl.buscar = buscar;
  $ctrl.options = {
    empresa: Catalogos.Empresas.find(function (empresa) {
      return empresa.ID_Empresa == $stateParams.idEmpresa
    }),
    nomina: Catalogos.Nominas && Catalogos.Nominas.find(function (nomina) {
      return nomina.ID_Nomina == $stateParams.idNomina
    }),
  };

  function buscar() {
    $location.search({
      idEmpresa: $ctrl.options.empresa && $ctrl.options.empresa['ID_Empresa'],
      idNomina: $ctrl.options.nomina && $ctrl.options.nomina['ID_Nomina'],
    });
  }

  function agregarMultiple() {
    let Empresas = $ctrl.catalogos.Empresas.filter(function (empresa) {
      return $ctrl.options.nomina.ID_Empresas_Asociadas.indexOf(empresa.ID_Empresa) >= 0;
    });

    $dialog.show('nominas.cargaNominaAsalariados.importar', {
      ID_Nomifan: $ctrl.options.nomina.ID_Nomifan,
      Empresas: Empresas,
      Seleccionadas: Empresas.map(function (empresa) {
        return empresa['ID_Empresa'];
      }),
    }).then(function (data) {
      data.forEach(function (item) {
        if (!index[item.UID]) {
          index[item.UID] = {
            UID: item.UID,
            Empleado: item.Empleado,
            Empresa: item.Empresa,
            ID_Empresa: item.ID_Empresa,
            ID_Empleado: item.ID_Empleado,
            Ingreso: 0,
          };
          $ctrl.data.push(index[item.UID]);
        }
        index[item.UID]['Ingreso'] += item.Data.reduce(function (prev, next) {
          return prev + Number(next[2]);
        }, 0);
      });
    });
  }

  function editar(item) {
    if (!$ctrl.saved)
      item['Ingreso'] = Number(prompt('Ingrese el importe.', item['Ingreso'])) || item['Ingreso'];
  }

  function borrar() {
    $ctrl.data.length = 0;
    index = {};
  }

  function guardar() {
    let validar = !$ctrl.options.nomina.Vacia
      ? $dialog.confirm('Ésta nómina tiene registros guardados, ¿Desea sobre escribirla?')
      : $q.when();

    validar.then(function () {
      let Nominas = {};
      $ctrl.data.forEach(function (row) {
        Nominas[row.UID] = Math.round(row.Ingreso * 100) / 100;
      });
      $ctrl.saving = true;
      NominasCargaNominaAsalariados.guardar($ctrl.options.empresa.ID_Empresa, $ctrl.options.nomina.ID_Nomina, Nominas)
        .then(function (response) {
          $ctrl.saved = true;
          $ctrl.options.ID_Nomina = response['ID_Nomina'];
        }).finally(function () {
        $ctrl.saving = false;
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/nominas/carganominaasalariados/routes/nominas-carganominaasalariados.js